var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container main-vacancies-container",attrs:{"rounded":""}},[_c('ProjectVacancies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }